// extracted by mini-css-extract-plugin
export default {"container":"PreviewMergePane_container__JQHGZ","wrapper":"PreviewMergePane_wrapper__4aYGg"};